export default "__VITE_ASSET__BqcumzLd__"